import { apiRequest } from '@/Groups/Scanner/private/imports/sharedUtils';

const BASE = '/api/screener';

//Получить данные графика по монете
export const apiGetChartData = ({ coin_slug }) =>
  apiRequest(`${BASE}/charts/?symbol=${coin_slug}`);

//Получить детали монеты для сравнения
export const apiGetCoinDetails = ({ impulse_type, base_asset_id, base_asset_type, compare_asset_id, compare_asset_type }) => {
  const params = new URLSearchParams({ base_asset_id, base_asset_type, compare_asset_id, compare_asset_type });
  return apiRequest(`${BASE}/compare/${impulse_type}/?${params}`);
};

//Получить список монет
export const apiGetCoinsList = ({ impulse_type, impulse_id, base_asset_id, page, type, category }) =>
  apiRequest(`${BASE}/${impulse_type}/coins/?${impulse_id}&base_asset_id=${base_asset_id}&type=${type}&page=${page}&${category}&page_size=100`);

//Получить фильтры динамики
export const apiGetDynamicsFilters = ({ base_coin_id, type }) =>
  apiRequest(`${BASE}/period-dyn/?base_asset_id=${base_coin_id}&type=${type}`);

//Получить фильтры импульсов
export const apiGetImpulsesFilters = ({ base_coin_id, type }) =>
  apiRequest(`${BASE}/impulse/?base_asset_id=${base_coin_id}&type=${type}`);